import script from "./HeaderBirthday.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBirthday.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBirthday.vue?vue&type=style&index=0&id=9fda326c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fda326c"]])

export default __exports__